<template lang="pug">
  .card
    h5.card-header How you can help
    .card-body
      p.card-text Hawaii CAN depends on donations from generous people like you. If you would like to give a monetary donation to Hawaii CAN, you can choose a one time donation or a recurring donation.
      p.card-text Click the Donate button below to make a one time contribution to Hawaii CAN.
      form.centered(action='https://www.paypal.com/cgi-bin/webscr', method='post', target='_blank')
        input(type='hidden', name='cmd', value='_s-xclick')
        input(type='hidden', name='hosted_button_id', value='3LN9JK4XPJHDW')
        input(type='image', src='https://www.paypal.com/en_US/i/btn/btn_donateCC_LG.gif', border='0', name='submit', alt='PayPal - The safer, easier way to pay online!')
</template>

<script>
export default {
  name: 'HowYouCanHelpCard'
};
</script>

<style scoped>
  .centered {
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/HowYouCanHelpCard.vue